import React, { useState, Fragment } from "react";
import Hidden from "@material-ui/core/Hidden";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";

import { Link, withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import { AppBar, Toolbar, Tooltip } from "@material-ui/core";
import { Box, List, IconButton } from "@material-ui/core";

import {
  Menu,
  Info,
  Home,
  People,
  // ViewList,
  InsertDriveFile,
} from "@material-ui/icons";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import DvrIcon from '@material-ui/icons/Dvr';

import AppsIcon from '@material-ui/icons/Apps';
// import BusinessIcon from '@material-ui/icons/Business';
// import CastForEducationIcon from '@material-ui/icons/CastForEducation';
import SchoolIcon from '@material-ui/icons/School';

import GmailSidebarItem from "@mui-treasury/components/sidebarItem/gmail";

import Logo from "../Logo/Logo";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 5,
  },
  list: {
    width: "219px",
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  appbar: {
    background: "linear-gradient(120deg, #2980b9, #8e44ad)",
  },
  navlink: {
    color: "inherit",
    textDecoration: "none",
  },
  navIcon: {
    marginRight: "1px !important",
    fontSize: "24px !important",
  },
  collapsed: {
    padding: "0px 4px !important",
  },
}));

const MenuList = (props) => {
  const classes = useStyles();

  const user = JSON.parse(localStorage.getItem("user"));
  const { close, collapsed, sideDraw, history } = props;
  const { onDrawclose } = props;

  const [index, setIndex] = useState(history.location.pathname);

  const commonProps = (i) => ({
    selected: index === i,
    onClick: () => setIndex(i),
    collapsed: sideDraw ? false : collapsed,
    dotOnCollapsed: true,
  });

  const Dashboard = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#da3125"}
            startIcon={<Home className={classes.navIcon} />}
            label={"Home"}
            amount={""}
            {...commonProps("/")}
            dotOnCollapsed={false}
          />
        </Link>
      </div>
    );
  });

  const Courses = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/courses" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#1a73e8"}
            startIcon={<SchoolIcon className={classes.navIcon} />}
            label={"Courses"}
            amount={""}
            {...commonProps("/courses")}
            dotOnCollapsed={false}
          />
        </Link>
      </div>
    );
  });

  const Vlab = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/vlab" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#1a73e8"}
            startIcon={<DvrIcon  className={classes.navIcon} />}
            // label={"Products"}
            label={"Virtual LAB"}
            amount={""}
            {...commonProps("/vlab")}
            dotOnCollapsed={false}
          />
        </Link>
      </div>
    );
  });

  const Sbooks = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/sbooks" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#1a73e8"}
            startIcon={<MenuBookIcon className={classes.navIcon} />} 
            label={"Smart Books"}
            amount={""}
            {...commonProps("/sbooks")}
            dotOnCollapsed={false}
          />
        </Link>
      </div>
    );
  });

  const Apps = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/apps" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#1a73e8"}
            startIcon={<AppsIcon className={classes.navIcon} />}
            label={"Apps"}
            amount={""}
            {...commonProps("/apps")}
            dotOnCollapsed={false}
          />
        </Link>
      </div>
    );
  });

  const CoursesManage = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/courses-management" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#8e44ad"}
            startIcon={<InsertDriveFile className={classes.navIcon} />}
            label={"Courses Manage"}
            amount={1000}
            {...commonProps("/courses-management")}
            dotOnCollapsed={true}
          />
        </Link>
      </div>
    );
  });

  const StudentsManage = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/users-management" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={"#e37400"}
            startIcon={<People className={classes.navIcon} />}
            label={"Students Manage"}
            amount={969}
            {...commonProps("/users-management")}
            dotOnCollapsed={true}
          />
        </Link>
      </div>
    );
  });

  const Help = React.forwardRef(function MyComponent(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        <Link to="/help" className={classes.navlink}>
          <GmailSidebarItem
            classes={{ collapsed: classes.collapsed, root: classes.root }}
            color={""}
            startIcon={<Info className={classes.navIcon} />}
            label={"Help"}
            amount={""}
            {...commonProps("/help")}
            dotOnCollapsed={true}
          />
        </Link>
      </div>
    );
  });

  return (
    <Box
      className={classes.list}
      role="presentation"
      onClick={close}
      onKeyDown={close}
    >
      <Box className={classes.toolbar}>
        <Hidden smUp>
          <AppBar position="absolute">
            <Toolbar className={classes.appbar}>
              <IconButton color="inherit" edge="start" onClick={onDrawclose}>
                <Menu />
              </IconButton>
              <Logo />
            </Toolbar>
          </AppBar>
        </Hidden>
      </Box>

      <List style={{ marginLeft: "-9px" }}>
        <Tooltip title="Home">
          <Dashboard />
        </Tooltip>

        <Tooltip title="Courses">
          <Courses />
        </Tooltip>

        <Tooltip title="Virtual Lab">
          <Vlab />
        </Tooltip>

        <Tooltip title="Smart Books">
          <Sbooks />
        </Tooltip>

        <Tooltip title="Applications">
          <Apps />
        </Tooltip>

        {user && user.maLoaiNguoiDung === "GV" ? (
          <Fragment>
            <Tooltip title="Courses Manage">
              <CoursesManage />
            </Tooltip>

            <Tooltip title="Students Manage">
              <StudentsManage />
            </Tooltip>
          </Fragment>
        ) : null}

        <Tooltip title="Help">
          <Help />
        </Tooltip>
      </List>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    collapsed: !state.ui.sideOpen,
    sideDraw: state.ui.sideDraw,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDrawclose: () => dispatch(actions.drawClose()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MenuList));
